import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrgSettingsLayout } from '@/features/organizations/settings/org-settings-layout'

export const Route = createFileRoute('/_authenticated/org/$orgId/settings')({
  beforeLoad: ({ context, params, location }) => {
    if (!context.isOrgAdmin) {
      throw redirect({
        to: '/org/$orgId',
        params,
      })
    }

    if (/\/settings\/?$/.test(location.pathname)) {
      throw redirect({
        to: '/org/$orgId/settings/general',
        params,
        replace: true,
      })
    }
  },
  component: OrgSettingsLayout,
})
